// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8ae5d777","977":"6b8d023a"}[chunkId] + ".chunk.js";
};